module.exports = __webpack_public_path__ + "img/6.ee2b2f7c.png";